/*!
 * Leiper's Fork Distillery — Big Thirst Cart Config v1.0.0
 *
 * Brand-specific config for the Big Thirst Cart engine.
 * Hosted on checkout-6.bigthirst.com Content > Files.
 *
 * Squarespace setup:
 *   Settings → Website Tools → Code Injection → Header:
 *   <script src="https://checkout-6.bigthirst.com/cdn/shop/files/leipers-fork-config.js"></script>
 *
 *   On the shop page, add a Code Block containing:
 *   <div id="bt-collection"></div>
 */

window.BigThirstCartConfig = {
  collectionHandle: 'leipers-fork-all-products',

  // Inventory display
  showInventory: true,
  inventoryThreshold: 10,
  inventoryInStockText: 'In Stock',

  cartNotice: 'All sales processed by retail partners of<br><strong>Big Thirst, Inc.</strong><br>Tax &amp; shipping calculated in next window.<br>Questions? <a href="mailto:help@bigthirst.com">help@bigthirst.com</a>',
  cartNoteSublabel: 'Discounts/Promo Codes Added During Checkout',
  cartNoteLabel: 'Order Note or Personalized Note for Recipient',
  cartNotePrefix: '-------Discounts/Promo Codes Added During Checkout----------------------Powered by Shop.BigThirst.com----------------',

  googleFonts: 'https://fonts.googleapis.com/css2?family=Open+Sans+Condensed:wght@300;700&display=swap',

  customCSS: '.bt-products { display: grid !important; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 36px; width: min(940px, 94vw); max-width: 94vw; position: relative !important; left: 50% !important; transform: translateX(-50%) !important; margin: 0 !important; } .bt-product { width: auto !important; margin: 0 !important; min-width: 0 !important; } .bt-product img { height: 400px !important; } .bt-add-btn { padding-top: 14px; padding-bottom: 14px; max-width: 300px; margin-left: auto; margin-right: auto; } .bt-product-description { color: #ffffff !important; font-size: 18px !important; } .bt-inventory { font-size: 18px !important; color: #0ac22c !important; } .bt-inventory.bt-inventory-low { color: #c00 !important; font-weight: 700 !important; } @media (max-width: 900px) { .bt-products { width: min(820px, 94vw); max-width: 94vw; gap: 24px; } }',

  cssVars: [
    '--bt-font: "Open Sans Condensed", sans-serif;',
    '--bt-price-color: #ffffff;',
    '--bt-price-size: 18px;',
    '--bt-text-color: #ffffff;',
    '--bt-title-size: 20px;',
    '--bt-title-weight: bold;',
    '--bt-title-margin: 8px;',
    '--bt-title-min-height: 55px;',
    '--bt-description-color: #ffffff;',
    '--bt-description-size: 18px;',
    '--bt-border-color: #7B250F;',
    '--bt-btn-bg: #7B250F;',
    '--bt-btn-color: #ffffff;',
    '--bt-btn-hover-bg: #5e1c0b;',
    '--bt-btn-hover-color: #ffffff;',
    '--bt-btn-px: 20px;',
    '--bt-btn-radius: 40px;',
    '--bt-add-btn-size: 18px;',
    '--bt-grid-gap: 30px;',
    '--bt-grid-bottom: 50px;',
    '--bt-toggle-icon-color: #ffffff;',
    '--bt-toggle-count-color: #ffffff;',
    '--bt-inventory-color: #0ac22c;',
    '--bt-inventory-low-color: #c00;',
    '--bt-notice-bold-color: #000;',
    '--bt-notice-link-color: #7B250F;',
  ].join(' '),
};

// Load the Big Thirst Cart engine
(function () {
  var s = document.createElement('script');
  s.src = 'https://checkout-6.bigthirst.com/cdn/shop/files/bigthirst-cart.js';
  s.async = true;
  document.head.appendChild(s);
})();
